var Lib = require ("./../../_gen/openfl/Lib").default;
module.exports.default = Lib.getDefinitionByName;